import NiceModal, { useModal } from "@ebay/nice-modal-react";
import DealSharingLinksForm from "models/sharings/DealSharingLinksForm";
import {
  useNiceModalLocker,
  NiceModalComponent,
} from "components/context/NiceModalProvider";

export default NiceModal.create(({ id, ...props }) => {
  const modal = useModal();
  const { setLocked, closeFormIfNotLocked } = useNiceModalLocker(modal);

  return (
    <NiceModalComponent open={modal.visible} onClose={closeFormIfNotLocked}>
      <DealSharingLinksForm
        setIsDirty={setLocked}
        objectId={id}
        onCancel={modal.hide}
        onDeleted={modal.hide}
        onCreated={modal.hide}
        {...props}
      />
    </NiceModalComponent>
  );
});
